import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND } from "@/lib/constants";

const links = [
  { to: "/", label: "Home" },
  { to: "/product", label: "Product" },
  { to: "/about", label: "About" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full border-b border-[#E2E8F0] bg-white/85 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-3"
          onClick={() => setOpen(false)}
        >
          <img
            src={BRAND.logos.qwis}
            alt="Q-Wis"
            className="h-11 w-11 sm:h-12 sm:w-12 object-contain rounded-[22%]"
          />
          <span className="hidden h-8 w-px bg-[#E2E8F0] sm:inline-block" />
          <img
            src={BRAND.logos.primecore}
            alt="PrimeCore Solutions"
            className="hidden h-12 w-auto sm:block"
          />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive
                    ? "text-[#0A1128]"
                    : "text-[#475569] hover:text-[#0A1128]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            data-testid="nav-cta-demo"
            onClick={() => navigate("/contact?intent=demo")}
            className="rounded-md bg-[#E8772E] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#D66826]"
          >
            Request a Demo
          </button>
        </div>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex items-center justify-center rounded-md p-2 text-[#0A1128] md:hidden"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#E2E8F0] bg-white md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2 text-base font-medium ${
                    isActive
                      ? "bg-[#F1F5F9] text-[#0A1128]"
                      : "text-[#334155] hover:bg-[#F8FAFC]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <button
              data-testid="nav-mobile-cta-demo"
              onClick={() => {
                setOpen(false);
                navigate("/contact?intent=demo");
              }}
              className="mt-2 rounded-md bg-[#E8772E] px-4 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-[#D66826]"
            >
              Request a Demo
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
